import { query_person_list } from 'liyu-pc-base/api/sys-model';

export default () => {
  const search_config: any = {
    model: {
      is_active: true,
      page_index: 1,
      pageSize: 2000,
    },
    watch: [],
  };
  return {
    getData: query_person_list,
    searchConfig: search_config,
  };
};
